import {商品区分型, 在庫区分型, 選択状態区分型} from '@/type/movement/item';
import {移動在庫商品型} from '@/type/movement/records/register/移動商品検索';

export interface 移動入力型 {
  商品コード: string;
  商品区分: 商品区分型;
  メーカー名: string;
  商品名: string;
  規格容量: string;
  移動年月日: Date | null;
  在庫部署コード: string;
  在庫部署名: string;
  移動先部署コード: string | null;
  箱数: number;
  バラ数: number;
  現在庫数: number;
  入数: number;
  入数表示: string;
  単位名: string;
  単位表示: string;
  在庫区分: 在庫区分型;
  有効期限: Date | null;
  移動後在庫数: number;
  バラ単位区分: バラ単位区分型;
  包装単位数: number;
  包装数量数: number;
  箱数バラ換算: number;
  総移動数: number;
}

export interface 選択移動在庫商品型 {
  選択状態区分: 選択状態区分型;
  移動入力: 移動入力型;
}

export interface 移動登録型 {
  商品コード: string;
  移動年月日: Date | null;
  在庫部署コード: string;
  移動先部署コード: string | null;
  箱数: number | null;
  バラ数: number | null;
  在庫区分: 在庫区分型;
  有効期限: Date | null;
}

export interface 移動登録依頼型 {
  移動登録依頼一覧: 移動登録型[];
}

export function to選択移動在庫商品型(record: 移動在庫商品型): 選択移動在庫商品型 {
  return {
    選択状態区分: 選択状態区分型.対象外,
    移動入力: {
      商品コード: record.商品コード,
      商品区分: record.商品区分,
      メーカー名: record.メーカー名,
      商品名: record.商品名,
      規格容量: record.規格容量,
      移動年月日: null,
      在庫部署コード: record.在庫部署コード,
      在庫部署名: record.在庫部署名,
      移動先部署コード: null,
      箱数: 0,
      バラ数: 0,
      現在庫数: record.現在庫数,
      入数: record.入数,
      入数表示: record.入数表示,
      単位名: record.単位名,
      単位表示: record.単位表示,
      在庫区分: record.在庫区分,
      有効期限: record.有効期限,
      移動後在庫数: record.現在庫数,
      バラ単位区分: record.バラ単位区分,
      包装単位数: record.包装単位数,
      包装数量数: record.包装数量数,
      箱数バラ換算: 0,
      総移動数: 0,
    },
  };
}

export interface 移動入力在庫場所結果型 {
  移動在庫場所結果一覧: 移動入力在庫場所型[];
}

export interface 移動入力在庫場所型 {
  部署コード: string;
  部署名: string;
}

export enum バラ単位区分型 {
  包装単位 = '包装単位',
  包装数量 = '包装数量',
}
